import { ActiveCurrencies, ActiveTimeZones, AirTicketActiveRights, ActiveAirlines, ActiveCardTypes } from './ActiveClasses';
import { Supplier_OficeID } from './RevenueManagementProperties';
export class SupplierTypeProperties {
  supplierTypeId: number = 0;
  name: string = "";
  creationUser: number = 0;
  creationDateTime: Date = new Date();
  modifyUser: number = 0;
  modifyDateTime: Date = new Date();
  isDeleted: boolean = false;
  status: boolean = false;
}
export class SuppliersProperties {
  supplierId: string = "";
  name: string = "";
  supplierTypeId: number = 0;
  status: boolean = false;
  creationUser: number = 0;
  creationDateTime: Date = new Date();
  modifyUser: number = 0;
  modifyDateTime: Date = new Date();
  isDeleted: boolean = false;
  backOfficeSupplierCode: string = "";
  providerCode: string = "";
  accessCodeList: SupplierAccessCodeProperties[] = [];
}
export class SupplierAccessCodeProperties {
  supplierAccessCodeId: number = 0;
  supplierId: string = "";
  accessCode: string = "";
  password: string = "";
  status: boolean = false;
  creationUser: number = 0;
  creationDateTime: Date = new Date();
  isDeleted: boolean = false;
  isCash: boolean = false;
  isCredit: boolean = false;
  repriceTrue: boolean = false;
  repriceFalse: boolean = false;
  settelmentId: number = 0;
  amount: number = 0;
  cardType: number = 0;
  cardNumber: string = "";
  cardExpiryDate: string = "";
  cVV: string = "";
  pinNumber: string = "";
  timeZoneId: number = 0;
  repriceBeforeIssuance: boolean = false;
  currencyId: number = 0;
  airlines: string[] = [];
  excludedAirlines: string[] = [];
  ticketRightsId: number[] = [];
  airlineRightsList: SupplierAccessCodesAirlineRightsProperties[] = [];
  modifyUser: number = 0;
  userName: string = "";
  targetBranch: string = "";
  canBook: boolean = false;
  canIssue: boolean = false;
  canRefund: boolean = false;
  canVoid: boolean = false;
  canExchange: boolean = false;
  canSearch: boolean = false;
  appliedOnAirline: string[] = [];

  companyId: number = 0;
  backOfficeSupplierCode: string = "";
  supplierCodesList: SuppliersList[] = [];
  iataCode: string = "";
}
export class SupplierAccessCodesAirlineRightsProperties {
  supplierAccessCodeAirlineRightsId: number = 0;
  supplierAccessCodeId: number = 0;
  airlineID: string = "";
  canBook: boolean = false;
  canIssue: boolean = false;
  canRefund: boolean = false;
  canVoid: boolean = false;
  canExchange: boolean = false;
  creationUser: number = 0;
  isAllAirlines: boolean = false;
  modifyUser: number = 0;
  isAllPrevious: boolean = false;
  canSearch: boolean = false;
  branch: string = "";

}


export class SuppliersList {

  // public string SupplierId { get; set; }
  supplierCode: string = "";
  supplierName: string = "";
  branchCode: string = "";
  groupName: string = "";
  status : string = "";
  //BranchCode : string = "";
  email : string = "";
  mobile : string = "";
  creditAllowed : string = "";
  creditAmount : string = "";
}



export class SupplierAccessCodeBaseData {

  timesList: ActiveTimeZones[] = [];

  currencyList: ActiveCurrencies[] = [];

  rightsList: AirTicketActiveRights[] = [];
  airlinesList: ActiveAirlines[] = [];
  cardList: ActiveCardTypes[] = [];
  todayLockDate: string = "";

}
export class BaseSaleOrderPreporties {
  vatRate: number = 0;
  suppliers: SupplierList[];
  primeAirLines: Prime[];
  iataCodeList: AirportIataCode[];
}
export class SupplierList {
  // backOffice
  supplierCode: string = "";
  supplierName: string = "";
}
export class Prime {
  primeAirline: string;

}
export class AirportIataCode {
  iataCode: string;
}


export class SuppliersListProperties {

  airSupplier: SupplierData[] = [];
  otherSupplier: SupplierData[] = [];
}
export class AccessCodeList {
  accessCodeId: number = 0;
  officeId: string = "";

  accessCodeStatus: boolean = false;

  currency: string = "";

  formOfPayment: string = "";

  previleges: string[] = [];


}
export class SupplierData {

  supplierTypeId: number = 0;
  providerCode: string = "";
  supplierId: string = "";

  supplierName: string = "";
  supplierStatus: boolean = false;

  codesList: AccessCodeList[] = [];


}

export class AgencySupplierRightsProperties {
  agencySupplierRightsId: number = 0;
  supplierId: string = "";
  agency_Branch: string = "";
  supplierOficeId: number = 0;
  status: boolean = true;
  creationUser: number = 0;
  creationDateTime: string = "";
  modifyUser: number = 0;
  mofidyDateTime: string = "";

  canBook: boolean = false;
  canIssue: boolean = false;
  canRefund: boolean = false;
  canVoid: boolean = false;
  canSearch: boolean = false;
}


export class AgencySupplierRightsList {
  supplierId: string
  name: string;
  creationUser: number = 0;
  agency_Branch: string = "";
  selectedOficeIds: string[] = [];
  supplierOficeIdlist: Supplier_OficeID[] = [];
  supplierRights = new AgencySupplierRightsProperties();
  supplierTypeId: number = 0;

}

export class AgencySupplierRightsdata {
  dataList: AgencySupplierRightsList[] = [];
  fromComponent: string;

}
export class ViewAgencySupplierRightsData {
  supplierId: string = "";

  supplierName: string = "";

  data: ViewAgencySupplierRights[] = [];

}

export class ViewAgencySupplierRights {
  supplierId: string = "";

  officeId: string = "";

  canBook: boolean = false;

  canIssue: boolean = false;
  canRefund: boolean = false;
  canVoid: boolean = false;
  canSearch: boolean = false;
}
